import contentRequest from '~/src/api/requests/contentRequest';
import profileRequest from '@stelecom/ui-react/components/requests/profileRequest';

export const getTariffs = (domainCity, isAuth, additionalParams) => {
    const expand = 'description,features,additionalProducts';
    return contentRequest.getWithCache(
        `${domainCity}/v1/internet-tariffs?expand=${expand}&filter[available]=1&filter` +
        `${isAuth ? '[available_client]=1' : '[available_guest]=1'}` +
        `${additionalParams ? additionalParams : ''}`
    );
};

export const getBanners = (domainCity, isAuth) => {
    return contentRequest.getWithCache(
        `${domainCity}/v2/banner-city/search?expand=bannerInfo&filter${
            isAuth ? '[available_auth]=1' : '[available_new]=1'
        }`
    );
};
/**
 * @param {string} domainCity
 * @param agreement
 * @param service
 * @param {string} accessToken
 * @return {Promise<*>}
 */
export const tariffActivate = async(domainCity, agreement, service, accessToken) => {
    const trId = service.terminalResources[0].id;
    const res = await profileRequest(
        domainCity,
        accessToken
    ).post('/tariff/activate', {
        params: {
            agreementId: agreement,
            trId: trId
        }
    });

    return await res.data;
};

/**
 * @param {string} domain
 * @param {string} accessToken
 * @return {Promise<*>}
 */
export const getContractPeriod = async(domain, accessToken) => {
    try {
        return await profileRequest(domain, accessToken).get('/tariff/period-contract-state');
    } catch (e) {
        console.error(e);
    }
};

export const getPenaltySum = async(domain, accessToken) => {
    try {
        return await profileRequest(domain, accessToken).get('/tariff/get-penalty-sum');
    } catch (e) {
        console.error(e);
    }
};

